import { useEffect } from "react";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import GitHubIcon from "@mui/icons-material/GitHub";
import "../Styles/Social.css";
import { socialAnim } from "../Animations";

export default function Social() {
  useEffect(() => {
    socialAnim();
  }, []);
  return (
    <section className="social-section">
      <h1 className="social-hero-text">
        <span>Stay in touch!</span>
        <small>👋</small>
      </h1>
      <p className="social-sub-title">Check out my online profiles.</p>
      <div className="social-links">
        <a
          href="https://www.instagram.com/pixelmanicdev/"
          className="social-icon"
          rel="noreferrer"
          target="_blank"
        >
          <InstagramIcon />
          <span>Instagram</span>
        </a>
        <a
          href="https://x.com/pixelmanicdev"
          className="social-icon"
          rel="noreferrer"
          target="_blank"
        >
          <XIcon />
          <span>X.com</span>
        </a>
        <a
          href="https://github.com/pixelmanic"
          className="social-icon"
          rel="noreferrer"
          target="_blank"
        >
          <GitHubIcon />
          <span>Github</span>
        </a>
      </div>
    </section>
  );
}
